module.exports = __webpack_public_path__ + "img/09207488fe9af6821e067c7e7d2ae04d.png";